import { CODIGO_OUTRA_NECESSIDADE } from '@/constants/codigosProduto'

/**
 * P1 (AN-PP1 §3.2): a reserva é "Outra necessidade"? Pelo CÓDIGO do produto (`OTHER_NEED`, lido
 * da projeção) ou, no legado, pela ausência de produto — nunca pelo nome.
 *
 * Ausência = `null` **ou** `undefined`: o módulo de oportunidades serializa com
 * `default-property-inclusion: non_null`, então a reserva legada sem produto chega SEM o campo
 * `produtoId` (nunca como `null`). Comparar com `=== null` escondia o legado (integração P1).
 */
export const reservaEhOutraNecessidade = (reserva: {
  produtoId?: string | null
  produtoCodigo?: string | null
}): boolean => reserva.produtoCodigo === CODIGO_OUTRA_NECESSIDADE || reserva.produtoId == null

export const ROTULO_OUTRA_NECESSIDADE = 'Outra necessidade'
